var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"margin-left":"0px","margin-right":"0px","padding-left":"0px","padding-right":"0px"},attrs:{"fluid":""}},[_c('result-road',{attrs:{"shoeResults":_vm.currentShoe,"bossCard":_vm.currentBossCard}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }